//@flow

import TextSearchFilter from './TextSearchFilter';
import CustomerInactivityFilterComponent from './CustomerInactivityFilter';
import CrmSegmentFilter from './CrmSegmentFilter';
import CrmTagsFilter from './CrmTagsFilter';
import CrmFunnelFilter from './CrmFunnelFilter';
import {FILTER_TYPES} from '../../../../utils/triggerConfig';

import type {TriggerFilterType} from '../../../../../../../entities';

export const TRIGGER_FILTER_COMPONENTS = {
  [FILTER_TYPES.TRIGGER_TEXT_SEARCH]: TextSearchFilter,
  [FILTER_TYPES.CUSTOMER_INACTIVITY]: CustomerInactivityFilterComponent,
  [FILTER_TYPES.CRM_SEGMENT]: CrmSegmentFilter,
  [FILTER_TYPES.CRM_TAGS]: CrmTagsFilter,
  [FILTER_TYPES.CRM_FUNNEL]: CrmFunnelFilter,
};

export type TriggerFilterComponentType = $Values<
  typeof TRIGGER_FILTER_COMPONENTS
>;

export function getFilterComponent(
  filterType: TriggerFilterType
): TriggerFilterComponentType {
  return TRIGGER_FILTER_COMPONENTS[filterType];
}
